/* ========================================================================
    Module: Confirm delete
 ========================================================================== */
/**
 * 削除実行のアラートを表示する
 *
 * @returns {void}
 */
const confirmDlete = (): void => {
    const linkElements =
        document.querySelectorAll<HTMLAnchorElement>(".js-delete");

    if (linkElements.length <= 0) {
        return;
    }

    linkElements.forEach((linkElemet) => {
        linkElemet.addEventListener("click", (e: MouseEvent): void => {
            e.preventDefault();

            let message = "削除しますがよろしいでしょうか？";

            if (linkElemet.dataset.message) {
                message = linkElemet.dataset.message.replaceAll(
                    /(?:<br>|\\n)/g,
                    "\n",
                );
            }

            if (window.confirm(message)) {
                const form = document.createElement("form");
                form.method = "POST";
                form.action = linkElemet.href;
                form.style.display = "none";
                form.innerHTML = `
                    <input type="hidden" name="_token" value="${linkElemet.dataset.csrfToken}">
                    <input type="hidden" name="_method" value="DELETE">
                `;

                document.body.append(form);
                form.submit();
            }
        });
    });
};

/**
 * 削除実行のアラートを表示する
 *
 * @returns {void}
 */
const confirmDleteLink = (): void => {
    const linkElements =
        document.querySelectorAll<HTMLAnchorElement>(".js-delete-link");

    if (linkElements.length <= 0) {
        return;
    }

    linkElements.forEach((linkElemet) => {
        linkElemet.addEventListener("click", (e: MouseEvent): void => {
            e.preventDefault();

            let message = "削除しますがよろしいでしょうか？";

            if (linkElemet.dataset.message) {
                message = linkElemet.dataset.message.replaceAll(
                    /(?:<br>|\\n)/g,
                    "\n",
                );
            }

            if (window.confirm(message)) {
                location.href = linkElemet.href;
            }
        });
    });
};

export { confirmDlete, confirmDleteLink };
